export const Skeleton = ({width}) => {
  return <div className="skeleton" style={{width}}></div>
}
